export const ANALYTICS_EVENT_NAME = {
  CUSTOM: 'custom-event',
  WEBINARS: 'webinars',
  HOME_QUIZ: 'home-quiz',
  LINK: 'link-click',
};

export const sendEvent = (data) => {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
};

export const sendQuizStepEvent = (category, step, label) => {
  const quizStepEventData = {
    event: ANALYTICS_EVENT_NAME.HOME_QUIZ,
    'ev-event-category': category,
    'ev-event-action': step,
    'ev-event-label': label,
  };

  sendEvent(quizStepEventData);
};

export const sendWebinarsEvent = (category, action, id, calendar) => {
  const webinarEvent = {
    event: ANALYTICS_EVENT_NAME.WEBINARS,
    'ev-event-category': category,
    'ev-event-action': action,
    'ev-event-label': id,
  };

  if (calendar) {
    webinarEvent['ev-event-calendar'] = calendar;
  }

  sendEvent(webinarEvent);
};

export const sendCustomEvent = ({ category, action, label }) => {
  const event = {
    event: ANALYTICS_EVENT_NAME.CUSTOM,
    'ev-event-category': category,
    'ev-event-action': action,
    'ev-event-label': label,
  };

  sendEvent(event);
};

export const sendCustomPageEvent = (action, _category = '') => {
  const category = _category || window.customPageEventCategory || null;

  if (window.customPageEventLabel && category) {
    sendCustomEvent({
      category,
      action,
      label: window.customPageEventLabel,
    });
  }
};

export const sendCustomPromoBannerEvent = (action) => {
  if (window.promoBannerEventLabel && window.promoBannerEventCategory) {
    sendCustomEvent({
      category: window.promoBannerEventCategory,
      action,
      label: window.promoBannerEventLabel,
    });
  }
};

export const sendLinkEvent = ({ category, action, label }) => {
  const event = {
    event: ANALYTICS_EVENT_NAME.LINK,
    'ev-event-category': category,
    'ev-event-action': action,
    'ev-event-label': label,
  };

  sendEvent(event);
};
